import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { iif, Observable, of, throwError } from 'rxjs';
import { catchError, retry, tap, timeout } from 'rxjs/operators';
import { Config } from './config';

const CONFIG_PATH: string = '/admin/config.json';
const TIMEOUT_MS: number = 5000;
const RETRIES: number = 1;

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any = undefined;

  constructor(private http: HttpClient) {}

  public getConfig(): Observable<any> {
    return iif(
      () => this.config !== undefined,
      of(this.config),
      this.http.get(CONFIG_PATH, { headers: null, responseType: 'text' }).pipe(
        timeout(TIMEOUT_MS),
        retry(RETRIES),
        tap((config) => {
          this.config = config;
          console.info(`Loaded config from server\n ${JSON.stringify(config)}`);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error loading config from server.', error);
          return throwError(() => new Error(`Error loading config from server. ${error.error}`));
        })
      )
    );
  }
}
